module.exports = __webpack_public_path__ + "img/gallery15.21237256.jpg";